import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import Routes from '../utils/routes.js.erb';
import { authHeaders } from '../actions';

const fetchReminderSendout = async (surveyId) => {
  const response = await axios.get(
    Routes.reminder_sendout_api_dashboard_asq_survey_path(surveyId),
    { headers: authHeaders() }
  );
  return response.data;
};

const enqueueReminderSendout = async (surveyId) => {
  const response = await axios.post(
    Routes.reminder_sendout_api_dashboard_asq_survey_path(surveyId),
    {},
    { headers: { ...authHeaders(), 'Content-Type': 'application/json' } }
  );
  return response.data;
};

export const useAsqReminderSendout = (surveyId) => {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ['asqReminderSendout', surveyId],
    queryFn: () => fetchReminderSendout(surveyId),
    enabled: false,
  });

  const mutation = useMutation({
    mutationFn: () => enqueueReminderSendout(surveyId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['asqReminderSendout', surveyId] });
    },
  });

  return {
    sendoutData: query.data,
    isLoadingSendouts: query.isLoading && query.fetchStatus !== 'idle',
    refetchSendouts: query.refetch,
    enqueueReminder: mutation.mutate,
    isEnqueuing: mutation.isPending,
  };
};
